import React, { useContext, useState, useEffect, useRef } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  Divider,
  Box,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { useReactToPrint } from "react-to-print";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import "../../App.css";
import { AuthContext } from "../../Context/AuthContext";
import ListBook from "./ListBook";

import PrintStudentBook from "./PrintStudentBook";

export default function ViewStudentBook({ open, handleClose, editData }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ទិន្នន័យសៀវភៅសិស្ស</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: 0 }}>
        <Stack width="100%" padding={3}>
          <Stack
            direction="row"
            width="100%"
            spacing={3}
            // padding={3}
            ref={componentRef}
            // bgcolor="red"
          >
            <Stack width="50%">
              <PrintStudentBook editData={editData} />
            </Stack>
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                borderStyle: "dashed",
                borderColor: "#f5f5f5",
                borderWidth: "0.5px",
                // height: "100%",
              }}
            />
            <Stack width="50%">
              <PrintStudentBook editData={editData} />
            </Stack>
          </Stack>
        </Stack>
        <Stack padding="30px">
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
              {/* {loading ? (
              <Button className="btn-create" fullWidth>
              កំពុងដំណើរការ...
              </Button>
              ) : ( */}
              <Button className="btn-create" fullWidth onClick={handlePrint}>
                បោះពុម្ព
              </Button>
              {/* )} */}
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
